<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>公司列表
        <div class="card-header-actions">
          <b-link v-if="!cannotEdit" @click="openEditor()"><i class="fa fa-plus"></i> 新增</b-link>
        </div>
      </b-card-header>
      <b-card-body>
      <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
        <a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>
        <a slot="super" slot-scope="props" class="d-inline-block text-center w-100"><span :class="props.row.super?'text-primary':'text-success'">{{props.row.super ? 'ALL' : 'SELF'}}</span></a>
        <a slot="parent_company_id" slot-scope="props">{{props.row.Parent?props.row.Parent.name:'N/A'}}</a>

        <div slot="child_row" slot-scope="props">
          <b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
          <b-button variant="danger" class="btn-pill" size="sm" v-if="!cannotEdit" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
          <b-button variant="success" class="btn-pill" size="sm" v-if="!cannotEdit" @click="genAdminLoginRow(props.row.id)"><i class="fa fa-qrcode"></i> 管理頁面QRCode</b-button> &nbsp;
          <b-button variant="success" class="btn-pill" size="sm" v-if="!cannotEdit" @click="genRegisterRow(props.row.id)"><i class="fa fa-qrcode"></i> 註冊頁面QRCode</b-button> &nbsp;
        </div>
      </v-server-table>
      </b-card-body>
    </b-card>

    <b-modal title="刪除公司" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
        {{delRowMsg}}
    </b-modal>

    <b-modal title="管理頁面QR Code" v-model="showAdminQrCode" ok-title="確定" cancel-title="取消">
      <div class="w-100 text-center">
          <canvas id="adminlogin-qrcode-canvas"></canvas>
          <p class="text-muted">管理頁面QRCode</p>
          <p class="text-primary"><a :href="adminlogin_uri" target="_blank">URI</a></p>
      </div>
    </b-modal>

    <b-modal title="註冊頁面QRCode" v-model="showRegisterQrCode" ok-title="確定" cancel-title="取消">
      <div class="w-100 text-center">
          <canvas id="register-qrcode-canvas"></canvas>
          <p class="text-muted">註冊頁面QRCode</p>
          <p class="text-primary"><a :href="register_uri" target="_blank">URI</a></p>
      </div>
    </b-modal>

    <b-modal title="編輯器" size="lg" class="modal-info" v-model="showEditorModal" @ok="submitRecord" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
        <b-form>
            <h1>公司資料</h1>
            <p class="text-muted">綠框為必填</p>
            
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clone"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="名稱" 
                            v-model.lazy.trim="$v.record.name.$model"
                            v-focus
                            :state="chkState('name')"
                            aria-describedby="invalidNameFeedback"/>
              <b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="cui-globe"></i> 所屬公司</b-input-group-text>
              </b-input-group-prepend>
              <b-form-select id="parent-company-id"
                            class="form-control hidden" 
                            placeholder="所屬公司..." 
                            v-model.lazy.trim="$v.record.parent_company_id.$model"
                            v-focus
                            :state="chkState('parent_company_id')"
                            aria-describedby="invalidPCIFeedback"/>
              <b-form-invalid-feedback id="invalidPCIFeedback">所屬公司必填</b-form-invalid-feedback>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-bolt"></i></b-input-group-text>
              </b-input-group-prepend>
              <v-select v-model="record.super" :options="super_options" placeholder="資料檢視權限" class="w-50"></v-select>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-map-signs"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="地址" 
                            v-model.lazy.trim="record.address"/>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-phone-square"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="電話" 
                            v-model.lazy.trim="record.phone"/>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-user-circle"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="聯絡人" 
                            v-model.lazy.trim="record.contact"/>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-chrome"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="公司網址" 
                            v-model.lazy.trim="record.url"/>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-font"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="統編" 
                            v-model.lazy.trim="record.idno"/>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa-commenting-o"></i> LINE通知ID</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="LINE通知ID" 
                            v-model.lazy.trim="record.client_id"/>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa-key"></i> LINE通知Key</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="LINE通知Key" 
                            v-model.lazy.trim="record.client_secret"/>
            </b-input-group>

            <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="icon-notebook icon"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea
                     v-model.lazy.trim="record.remarks"
                     placeholder="備註"
                     :rows="3"
                     :max-rows="6">
                </b-form-textarea>
            </b-input-group>

        </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
import qrcode from 'qrcode'
import sha1 from 'sha1'
import _ from 'lodash'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

const clean_form = {
  name:    '',
  parent_company_id: 1,
  url:     '',
  address: '',
  phone:   '',
  contact: '',
  idno:    '',
  remarks: '',
  client_id: '',
  client_secret: '',
  super:   false,
};

//let $selec2 = null;
let $parent_company_id_select2 = null;

Vue.use(ServerTable)

export default {
  name: 'company_list',
  notifications,
  components: {
    ServerTable,
    Event,
    Multiselect,
    vSelect
  },
  data(){
    let app = this;
    let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;

    return {
      cannotEdit,
      super_options: [
        {label:'可以看到全部公司資料', value:true},
        {label:'只能看到自己與子公司資料', value:false}
      ],
      device_uri: '',
      showRegisterQrCode: false,
      showAdminQrCode: false,
      isFindingLoading: false,
      editRowId: null,
      record: Object.assign({}, clean_form),
      showEditorModal: false,
      delRowShowModal: false,
      delRowId: 0,
      delRowMsg: '',
      adminlogin_uri: '',
      register_uri: '',
      columns: ['id', 'name','parent_company_id', 'super', 'contact', 'phone', 'idno', 'client_id', 'remarks', 'created'],
      data: [],
      options: {
        headings: {
          id:  'id',
          name:  '名稱',
          parent_company_id: '所屬公司',
          super: '檢視權限',
          contact: '聯絡人',
          phone: '電話',
          idno: '統編',
          client_id: 'LINE通知',
          remarks: '備註',
          user_id: '建立人',
          created: '建立時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['name', 'super', 'address', 'contact', 'idno', 'phone', 'created'],
        filterable: ['name', 'address', 'contact', 'phone'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          
          let action = `${admin_root}/get_list/Company`;
          let params = {
              keyset: 'mqtt',
              token: app.$state.$get('adminuser').token
          };

          for(let col in data){
            params[col] = data[col];
          }

          return app.$jsonp(action, params);//return the Promise
        }//eo requestFunction
      },
      useVuex: false,
          theme: 'bootstrap4',
          template: 'default'
    };//eo return
  },//eo data

  methods: {

    editRow(row_id, row) {
      this.record = Object.assign({}, row);
      this.openEditor(row_id);
    },//eo editRow

    delRow(row_id, row_name) {
      // console.info('del row_id:', row_id);

      this.delRowShowModal = row_id ? true : false;
      this.delRowId        = row_id;
      this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
    },//eo delRow

    submitDelRow(row_id) {
      
      let app    = this;
      let action = `${admin_root}/update_record/Company`;
      let params = {
          keyset: 'mqtt',
          token:  app.$state.$get('adminuser').token,
          record: encodeURIComponent(encrypt(JSON.stringify({
            id: row_id,
            field: 'valid',
            value: 0,
            value_type: 'int'
          })))
      };
      
      app.$jsonp(action, params).then((result) => {

        // console.info('result:', result);

        if(result.success){
          app.showSuccess({
            title: '資料更新成功',
            message: result.message
          });

          app.$refs['dataTable'].refresh();
        } else {
          app.showError({
            title: '資料更新失敗',
            message: result.message
          });
        }

      }).catch((error) => {
        console.info('update_device error:', error);
      });
    },

    testRow(row_id) {
      console.info('test row_id:', row_id);
      this.showWarn({
        message: '開發中',
        title: '功能暫停'
      });
    },//eo testRow

    chkState(val) {
      const field = this.$v.record[val];
      return !field.$dirty || !field.$invalid;
    },

    openEditor(row_id){
      this.showEditorModal = true;
      this.$v.$reset();
      let page_limit = 10;
    	let app        = this;

      //workaround for select2 to be able to use search input
      jQuery('div.modal-content').removeAttr('tabindex');

      $parent_company_id_select2 = jQuery('#parent-company-id');

      if($parent_company_id_select2.length){
        //console.info('parent_company_id_select2.length: ', $parent_company_id_select2.length);

        //init select2
        $parent_company_id_select2.select2({
          width: 'copy',
          dropdownAutoWidth: true,
          placeholder: '所屬公司...',
          allowClear: true,
          ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
              url: `${admin_root}/get_option_list/Company`,
              dataType: 'jsonp',
              quietMillis: 800 ,
              data: function (params) {
                  let preselected_id = jQuery(this).val();
                  return {
                      preselected_id: preselected_id,
                      query:          params.term, // search term
                      page_limit:     page_limit,
                      page:           params.page || 1,
                      token:          app.$state.$get('adminuser').token
                  };
              },
              results: function (data, page) {
                  var more = (page * page_limit) < data.total;
                  return {results: data.results, more: more};
              }
          },//eo ajax
        }).on('change', (event) => {
          app.record.parent_company_id = $parent_company_id_select2.select2('val');
        });
      }//eo $parent_company_id_select2 init

      //workaround for Bootstrap4
      if($parent_company_id_select2.data('select2')){
        $parent_company_id_select2.data('select2').$container.addClass("form-control");
      }

      if(row_id && this.record){
        this.editRowId       = row_id;
      } else {
        this.editRowId       = null;
        this.record       = Object.assign({}, clean_form);
        this.row_id       = null;
      }
      let $option1 = jQuery('<option selected>讀取中...</option>').val(this.record.parent_company_id);
      //$parent_company_id_select2.val(this.record.parent_company_id).trigger('change');

      this.$jsonp(`${admin_root}/get_option_list/Company`, {
        token: this.$state.$get('adminuser').token,
        id: this.record.parent_company_id
      }).then((result) => {
        if(result.results.length){
          let rec = result.results.pop();
          $option1.text(rec.text).val(rec.id);
          $option1.removeData();

          $parent_company_id_select2.html('');

          $parent_company_id_select2.append($option1);

          $parent_company_id_select2.trigger({
            type: 'select2:select',
            params: {
              data: rec
            }
          });

          $parent_company_id_select2.val(rec.id).trigger('change');
        } else {
          // $option.revmove();
          $parent_company_id_select2.val(null);
          app.showError({
            message: '無法讀取公司資料，請重新指定'
          });
        }
      });

      //console.info('record:', this.record);

      //console.info('this.record[super]', this.record['super']);
      this.record['super'] = this.record['super'] ? '可以看到全部公司資料' : '只能看到自己與子公司資料';

      //console.info('this.record[client_id]', this.record['client_id']);
      //console.info('this.record[client_secret]', this.record['client_secret']);
    },

    submitRecord() {

      let app    = this;
      let row_id = app.editRowId;
      this.$v.$touch();

      if (this.$v.$invalid) {
          this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
          return false;
      }

      //console.info('app.record:', app.record);

      let to_save = app.record;

      if(row_id){
        to_save['id'] = row_id;
      }

      to_save['super'] = app.record['super'].value == true ? true : false;

      if(to_save['client_id'] == null || to_save['client_id'].length == 0) {
        //delete to_save['client_id'];
        to_save['client_id'] = null;
      }

      if(to_save['client_secret'] == null || to_save['client_secret'].length == 0) {
        //delete to_save['client_secret'];
        to_save['client_secret'] = null;
      }

      //console.info('to_save:', to_save);

      to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

      let action = `${admin_root}/save_record/Company`;
      let params = {
        keyset: 'mqtt',
        token:  this.$state.$get('adminuser').token,
        record: to_save
      };

      this.$jsonp(action, params).then((result) => {
        if(result.success){
          app.showSuccess({
            title: '成功',
            message: '資料成功儲存'
          });
          app.$refs['dataTable'].refresh();
          app.record = Object.assign({}, clean_form);
          app.$v.$reset();
        } else {
          app.showError({
            title: '錯誤',
            message: '無法儲存資料，請稍後再試'
          });
          app.$refs['dataTable'].refresh();
        }
      });
    },

    genAdminLoginRow(row_id) {
      this.showAdminQrCode = true;
      row_id               = encodeURIComponent(config.encrypt(''+row_id, config.ffkey, config.ffiv));

      let msg = `${config.frontend_entry}/#/_admin_?ccid=${row_id}`;
      qrcode.toCanvas(document.getElementById('adminlogin-qrcode-canvas'), msg);
      this.adminlogin_uri = msg;
    },//eo genAdminLoginRow

    genRegisterRow(row_id) {
      // console.info('row clicked: ', row_id);
      this.showRegisterQrCode = true;
      row_id                  = encodeURIComponent(config.encrypt(''+row_id, config.ffkey, config.ffiv));

      let msg = `${config.frontend_entry}/#/aregg?ccid=${row_id}`;
      qrcode.toCanvas(document.getElementById('register-qrcode-canvas'), msg);
      this.register_uri = msg;
    },//eo genAdminLoginRow

  },//eo methods

  validations: {
    record: {
      name: {
        required,
        minLength: minLength(2)
      },
      super: {
        required,
      },
      parent_company_id: {
			  required,
			  integer
			  // minLength: minLength(1)
			},
    }
  },//eo validations
  
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.multiselect__input{width:100%;border:none;}
.qrcode-canvas{
  display:inline-block;
  margin: auto;
}
#dataTable {
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5rem;
  font-size: 0.75rem;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center ;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }

  .VueTables__sortable {
    padding: 0.25rem;
  }
}
</style>
